// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// GES-253 — the i18n runtime must be initialised before the first render, so it is imported
// for its side effect here rather than inside a component. It sets no language of its own:
// AuthContext applies the signed-in user's stored preference as soon as /api/me answers.
import './i18n';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
